var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 4,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.2l-.88-.8C7.18 11.55 5.75 10.28 5.75 8.65 5.75 7.38 6.73 6.4 8 6.4c.74 0 1.45.35 1.9.9.45-.55 1.16-.9 1.9-.9 1.27 0 2.25.98 2.25 2.25 0 1.63-1.43 2.9-3.37 4.75L10 14.2z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientHealthIcon);
export default __webpack_public_path__ + "static/media/ClientHealthIcon.2e4a8756d77cd90b24d1f18a5a6f26c8.svg";
export { ForwardRef as ReactComponent };